"use client"

import React, { useEffect, useState, useContext } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import { motion } from "framer-motion"
import { FaUserTie, FaMoneyBillWave, FaChartLine, FaCheckCircle } from "react-icons/fa"
import { CircuitoContext } from "../../context/CircuitoContext"
import "../../styles/circuitoDesignSystem.css"

const API = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api"

export default function CircuitoAfiliadoDashboard() {
  const { codigo } = useParams()
  const { circuito, loadingCircuito } = useContext(CircuitoContext)
  
  const [dados, setDados] = useState(null)
  const [erro, setErro] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (circuito?._id && codigo) {
      buscarDashboard();
    }
  }, [circuito, codigo])

  const buscarDashboard = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/circuitos/${circuito._id}/dashboard-afiliado/${codigo}`);
      setDados(res.data);
    } catch (err) {
      setErro("Painel de afiliado não encontrado ou link inválido.");
    } finally {
      setLoading(false);
    }
  }

  if (loadingCircuito || loading) {
    return (
      <div className="circuito-shell">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
          <div className="loading-spinner"></div>
        </div>
      </div>
    )
  }

  if (erro) {
    return (
      <div className="circuito-shell" style={{ textAlign: "center", padding: "60px 20px", color: "#f87171" }}>
        <h2>⚠️ {erro}</h2>
      </div>
    )
  }

  const fC = (v) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

  return (
    <div className="circuito-shell">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ maxWidth: 800, margin: "0 auto", padding: "40px 16px" }}
      >
        {/* Cabeçalho do Afiliado */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ display: "inline-flex", padding: "12px", background: "rgba(255,255,255,0.05)", borderRadius: "50%", marginBottom: 16 }}>
            <FaUserTie size={40} color="var(--c-accent)" />
          </div>
          <h1 style={{ fontSize: "28px", fontWeight: 800, color: "#fff", marginBottom: 8 }}>
            Painel do Parceiro
          </h1>
          <p style={{ fontSize: "16px", color: "var(--c-accent)", fontWeight: 600 }}>
            {dados?.afiliado?.nome}
          </p>
        </div>

        {/* Cards de Resumo */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 20, marginBottom: 40 }}>
          <div style={{ background: "var(--c-card)", padding: 24, borderRadius: 16, border: "1px solid rgba(255,255,255,0.08)", boxShadow: "0 8px 30px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 13, textTransform: "uppercase", fontWeight: "bold" }}>Associações Pagas</span>
              <FaCheckCircle size={20} color="#10b981" />
            </div>
            <strong style={{ fontSize: "36px", color: "#fff", display: "block" }}>{dados?.qtdVendas}</strong>
          </div>

          <div style={{ background: "var(--c-card)", padding: 24, borderRadius: 16, border: "2px solid var(--c-accent)", boxShadow: "0 8px 30px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <span style={{ color: "var(--c-accent)", fontSize: 13, textTransform: "uppercase", fontWeight: "bold" }}>Total Arrecadado</span>
              <FaMoneyBillWave size={20} color="var(--c-accent)" />
            </div>
            <strong style={{ fontSize: "32px", color: "#fff", display: "block" }}>{fC(dados?.valorArrecadado)}</strong>
          </div>
        </div>

        {/* Histórico de Vendas */}
        <div style={{ background: "var(--c-card)", borderRadius: 16, border: "1px solid rgba(255,255,255,0.08)", padding: 24 }}>
          <h3 style={{ fontSize: 18, color: "#fff", marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <FaChartLine color="var(--c-accent)" /> Extrato de Indicações (Pagas)
          </h3>

          {dados?.ultimasVendas?.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "rgba(255,255,255,0.4)" }}>
              Nenhuma indicação paga até o momento.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {dados.ultimasVendas.map((venda) => (
                <div key={venda.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", background: "rgba(255,255,255,0.02)", borderRadius: 12, border: "1px solid rgba(255,255,255,0.04)" }}>
                  <div>
                    <strong style={{ color: "#fff", display: "block", fontSize: 15, marginBottom: 4 }}>{venda.nomeVaqueiro}</strong>
                    <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 12 }}>{venda.categoria} • {new Date(venda.data).toLocaleDateString('pt-BR')}</span>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <strong style={{ color: "#10b981", fontSize: 16 }}>{fC(venda.valor)}</strong>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    </div>
  )
}